import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import s from './CookieConsent.module.scss';

const COOKIE_KEY = 'cookie-consent';

const CookieConsent: FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const stored = localStorage.getItem(COOKIE_KEY);
            if (stored !== 'accepted') {
                setVisible(true);
            }
        } catch {
            // если localStorage недоступен — просто показываем баннер
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        try {
            localStorage.setItem(COOKIE_KEY, 'accepted');
        } catch {
            // игнорируем ошибки записи
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <section className={s.banner} aria-label="Уведомление об использовании cookie">
            <div className={s.content}>
                <p className={s.text}>
                    Мы используем cookie-файлы для улучшения работы сайта и анализа статистики.
                    Продолжая использовать сайт, вы соглашаетесь с использованием cookie.
                    Подробнее в&nbsp;
                    <Link to="/privacy-policy" className={s.link}>
                        Политике конфиденциальности
                    </Link>
                    .
                </p>
                <button type="button" className={s.button} onClick={handleAccept}>
                    Согласен
                </button>
            </div>
        </section>
    );
};

export default CookieConsent;


